import { Api } from './axios-config';

export interface ICommissionAdjustmentView {
  id: number;
  businessEmployeeId: number;
  employeeName: string;
  businessId: number;
  amount: number;
  type: number; // 0=Bonus, 1=Discount, 2=Advance
  typeName: string;
  description: string;
  createdByUserId: number;
  createdByUserName: string;
  createdAt: Date;
  deducted: boolean;
}

export interface ICreateCommissionAdjustmentDto {
  businessEmployeeId: number;
  businessId: number;
  amount: number;
  type: number;
  description: string;
  createdByUserId: number;
}

export interface ICommissionAdjustmentSummary {
  businessEmployeeId: number;
  employeeName: string;
  totalBonuses: number;
  totalDiscounts: number;
  totalAdvances: number;
  netAdjustment: number;
}

const getByBusiness = async (
  businessId: number,
  businessEmployeeId?: number,
  type?: number
): Promise<ICommissionAdjustmentView[]> => {
  const params = new URLSearchParams();
  params.append('businessId', businessId.toString());
  if (businessEmployeeId) params.append('businessEmployeeId', businessEmployeeId.toString());
  if (type !== undefined) params.append('type', type.toString());

  const { data } = await Api.get<ICommissionAdjustmentView[]>(`/commissionadjustment?${params.toString()}`);
  return data;
};

const getSummary = async (
  businessId: number,
  businessEmployeeId: number
): Promise<ICommissionAdjustmentSummary> => {
  const params = new URLSearchParams();
  params.append('businessId', businessId.toString());
  params.append('businessEmployeeId', businessEmployeeId.toString());

  const { data } = await Api.get<ICommissionAdjustmentSummary>(`/commissionadjustment/summary?${params.toString()}`);
  return data;
};

const create = async (dto: ICreateCommissionAdjustmentDto): Promise<ICommissionAdjustmentView> => {
  const { data } = await Api.post<ICommissionAdjustmentView>('/commissionadjustment', dto);
  return data;
};

const remove = async (id: number): Promise<void> => {
  await Api.delete(`/commissionadjustment/${id}`);
};

const markDeducted = async (id: number): Promise<void> => {
  await Api.post(`/commissionadjustment/${id}/deduct`);
};

export const commissionAdjustmentService = {
  getByBusiness,
  getSummary,
  create,
  remove,
  markDeducted,
};
